import { API } from "./api";

/** Download a CSV from a backend export endpoint. Uses cookies for auth. */
export async function downloadCSV(path, filename) {
  const resp = await fetch(`${API}${path}`, { credentials: "include" });
  if (!resp.ok) throw new Error("Export failed");
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** Open a backend file (e.g. uploaded bill) in a new tab using blob URL with cookies */
export async function openBackendFile(path) {
  const resp = await fetch(`${API}/files/${path}`, { credentials: "include" });
  if (!resp.ok) throw new Error("Cannot open file");
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
